import * as React from "react";
import {
  orderByEvent,
  groupByEvent,
  timeFrameEvent,
} from "../../../../utils/eventTracking";
import {
  TRACKING_EVENT_ORDER_BY,
  TRACKING_EVENT_GROUP_BY,
  TRACKING_EVENT_TIME_FRAME,
  VIEW_BY_OPTIONS,
} from "../../../../context/reports/comfort/constants";
import { useActions as useComfortActions } from "../../../../context/reports/comfort/useActions";
import { RankDir, ViewBy } from "../../../../context/reports/comfort/types";

export function useTrackedActions() {
  const { setRankDir, setViewBy, setTimeFrame } = useComfortActions();

  const trackedRankDir = React.useCallback(function trackedOrderBy(
    chartTitle: string
  ) {
    return (value: RankDir) => {
      const chartOrder = value === "worst" ? "least to most" : "most to least";
      orderByEvent(
        {
          chartTitle,
          chartOrder,
        },
        TRACKING_EVENT_ORDER_BY
      );
      setRankDir(value);
    };
  },
  []);

  const trackedViewBy = React.useCallback(function trackedGroupBy(
    chartTitle: string
  ) {
    return (value: ViewBy) => {
      groupByEvent(
        {
          chartTitle,
          chartGrouping: VIEW_BY_OPTIONS.find((o) => o.value === value)!.label,
        },
        TRACKING_EVENT_GROUP_BY
      );
      setViewBy(value);
    };
  },
  []);

  const trackedTimeFrame: typeof setTimeFrame = React.useCallback(
    function trackedTimeFrame(timeFrameOption, compareToOption) {
      timeFrameEvent({ timeFrameOption }, TRACKING_EVENT_TIME_FRAME);
      setTimeFrame(timeFrameOption, compareToOption);
    },
    []
  );

  return {
    trackedRankDir,
    trackedViewBy,
    trackedTimeFrame,
  };
}
